import { render } from "./PartnerWrapper.vue?vue&type=template&id=497bed12&scoped=true&ts=true"
import script from "./PartnerWrapper.vue?vue&type=script&lang=ts"
export * from "./PartnerWrapper.vue?vue&type=script&lang=ts"

import "./PartnerWrapper.vue?vue&type=style&index=0&id=497bed12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497bed12"]])

export default __exports__